import React, { useState, useEffect, useRef, useCallback } from 'react';

const images = [
    'https://wp.atsautodetailandsales.com/wp-content/uploads/2025/03/IMG_5778.jpeg',
    'https://wp.atsautodetailandsales.com/wp-content/uploads/2025/03/IMG_5768.jpeg',
    'https://wp.atsautodetailandsales.com/wp-content/uploads/2025/03/IMG_5765.jpeg',
    'https://wp.atsautodetailandsales.com/wp-content/uploads/2024/10/IMG_5800.jpeg',
    'https://wp.atsautodetailandsales.com/wp-content/uploads/2021/10/istockphoto-1273682054-170667a.jpg',
    'https://wp.atsautodetailandsales.com/wp-content/uploads/2025/03/det_interior.webp',
];

const DetailingCarousel = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [touchStart, setTouchStart] = useState(0);
    const [touchEnd, setTouchEnd] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const carouselRef = useRef(null);
    
    const itemsPerSlide = 1;
    const totalSlides = Math.ceil(images.length / itemsPerSlide);
    
    const nextSlide = useCallback(() => {
        setCurrentIndex((prevIndex) => {
            const nextIndex = prevIndex + 1;
            if (totalSlides > 0) {
                return nextIndex >= totalSlides ? 0 : nextIndex;
            }
            return 0; // Default to 0 if totalSlides is 0
        });
    }, [totalSlides]);
    
    // Touch handlers
    const handleTouchStart = (e) => {
        setTouchStart(e.targetTouches[0].clientX);
        setIsDragging(true);
    };
    
    const handleTouchMove = (e) => {
        if (!isDragging) return;
        setTouchEnd(e.targetTouches[0].clientX);
    };
    
    const handleTouchEnd = () => {
        setIsDragging(false);
        
        // Minimum swipe distance threshold
        const minSwipeDistance = 50;
        
        if (!touchStart || !touchEnd) return;
        
        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > minSwipeDistance;
        
        // Only respond to left swipes
        if (isLeftSwipe) {
            nextSlide();
        }
        
        // Reset touch positions
        setTouchStart(0);
        setTouchEnd(0);
    };
    
    // Auto-scroll every 5 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            if (!isDragging) {
                nextSlide();
            }
        }, 5000);
        
        return () => clearInterval(interval);
    }, [isDragging, currentIndex, nextSlide]);

    // Create a complete set of images to handle edge cases
    const prepareImageSet = () => {
        // Duplicate the array to ensure we have enough items for smooth looping
        const extendedImages = [...images, ...images];
        return extendedImages;
    };

    const imageSet = prepareImageSet();
    
    return (
        <div className="relative w-full mx-auto overflow-hidden">
            <div 
                className='flex justify-between items-center mb-4 transition-transform duration-500 ease-in-out'
                style={{ transform: `translateX(-${currentIndex * 33.33}%)` }}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
                ref={carouselRef}
            >
                {imageSet.map((image, index) => (
                    <div 
                        key={index} 
                        className="relative min-w-[33.33%] flex-shrink-0 h-96 overflow-hidden px-1"
                    >
                        <img
                            src={image}
                            alt={`Slide ${index % images.length}`}
                            className="absolute inset-0 object-cover w-full h-full"
                            loading='lazy'
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DetailingCarousel;